import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddChapter from "../../../containers/admin/chapters/models/add-chapter";
import SearchBar from "../../../containers/admin/chapters/searchbar";
import ChaptersTable from "../../../containers/admin/chapters/table";
import { getAllChaptersRequest } from "../../../modules/admin-modules/chapters/Actions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

/**
 * Lists lesson rows with active = 0 (inactive), using the same chapters API as Lessons.
 * Optional query `active=0` is sent when the backend supports it; the table also filters client-side.
 */
const QuestionContainers = () => {
  const dispatch = useDispatch();
  const chapters = useSelector((state) => state.chapters.chapters);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const totalCount = useMemo(
    () =>
      (Array.isArray(chapters) ? chapters : []).filter((c) => Number(c?.active) === 0).length,
    [chapters]
  );

  useEffect(() => {
    dispatch(getAllChaptersRequest());
    dispatch(getAllAdminSectionsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        pageTitle="Question containers"
        pageSubtitle="Containers for organizing questions and answers."
        countLabel="Total containers:"
        totalCount={totalCount}
        showAddButton
        addButtonLabel="Add container"
        searchPlaceholder="Search by container name…"
      />
      <ChaptersTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        inactiveOnly={true}
      />
      <AddChapter
        key={`chapter-qc-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        defaultActive={0}
        image={false}
      />
    </Layout>
  );
};

export default QuestionContainers;
